import { useEffect } from 'react';

const useOnKeypress = (
  key: KeyboardEvent['key'],
  listener: (...args: any) => void,
  enabled = true
) => {
  useEffect(() => {
    const fn = (e: KeyboardEvent) => {
      if (e.key === key) {
        listener(e);
      }
    };

    if (enabled) {
      window.addEventListener('keydown', fn);
    } else {
      window.removeEventListener('keydown', fn);
    }

    () => {
      window.removeEventListener('keydown', fn);
    };
  }, [key, enabled, listener]);
};

export default useOnKeypress;
